import { gql } from "@apollo/client";

export const UPDATE_GITHUB_INTEGRATION = gql`
  mutation UpdateGitHubIntegration($vcsChecks: VCSCheck!) {
    githubIntegrationUpdate(vcsChecks: $vcsChecks) {
      vcsChecks
    }
  }
`;
